import { HOST } from '@/utils/request'
import { App_User } from '@/data/user_info'
const { VUE_APP_TYPE } = process.env

const page_title = VUE_APP_TYPE === 'tft' ? '成都购房通' : '新房在线'

import wx from '@/utils/wx'

export const getElementHeight = (id) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            wx.createSelectorQuery().select(`#${id}`).fields({
                size: true
            }, (res) => {
                if (res) {
                    resolve(res.height)
                } else {
                    resolve(0)
                }
            }).exec()
        })
    })
}

const updateTip = () => {
    wx.showModal({
        title: '提示',
        content: '当前微信版本过低，无法使用该功能，请升级到最新微信版本后重试。'
    })
}

let system_info
let ios_checked = false
let is_ios = false

export function getSystemInfo () {
    if (system_info) {
        return system_info
    }
    system_info = {}
    return system_info
}

export const checkIOS = async () => {
    if (ios_checked) {
        return is_ios
    }
    const { system } = await WX_API.getSystemInfo()
    is_ios = system.substring(0, 3).toLowerCase() === 'ios'
    ios_checked = true
    return is_ios
}

export const checkChooseImg = () => {
    return ''
}

const WX_API = {
    login: () => new Promise((resolve, reject) => {
        wx.login({
            success: (res) => {
                if (res.code === 'error') {
                    reject(res)
                } else {
                    App_User.setJscode(res.code)
                    resolve(res)
                }
            },
            fail: reject
        })
    }),
    checkSession: () => new Promise((resolve, reject) => {
        const token = wx.getStorageSync('token')
        console.error(token, App_User.getJscode())
        if (token) {
            resolve({
                code: App_User.getJscode()
            })
        } else {
            console.warn('checksession no token fail')
            reject()
        }
    }),
    getFile (filePath) {
        return new Promise((success, fail) => {
            wx.getFileSystemManager().readFile({
                filePath,
                success,
                fail
            })
        })
    },
    uploadImg (filePath, opts = {}) {
        const formData = {}
        if (opts.store_dir) {
            formData.store_dir = opts.store_dir
        }
        console.error('formData', formData)
        return new Promise((resolve, reject) => {
            return wx.uploadFile({
                url: 'https://data-api.rippletek.com/miniapp/v1/upload_images',
                filePath,
                header: {
                    'content-type': 'application/json'
                },
                name: 'image',
                formData,
                success: async (res) => {
                    if (res.statusCode === 422) {
                        const { meta } = JSON.parse(res.data)
                        console.error(res, meta)
                        wx.showToast({
                            icon: 'none',
                            title: meta.error_message
                        })
                    } else if (res.statusCode === 413) {
                        wx.showModal({
                            title: '提示',
                            content: '上传图片不能超过8M',
                            showCancel: false
                        })
                        reject(res.statusCode)
                    } else {
                        const { data } = JSON.parse(res.data)
                        const { image_ssl_url } = data
                        resolve(image_ssl_url)
                    }
                },
                fail (res) {
                    reject(res)
                }
            })
        })
    },
    uploadAudio (filePath) {
        return new Promise((resolve, reject) => {
            return wx.uploadFile({
                url: `${HOST}/fc/v1/upload_audios`,
                filePath,
                header: {
                    'content-type': 'application/json',
                    'Authorization': wx.getStorageSync('token')
                },
                name: 'audio',
                success: async (res) => {
                    if (res.statusCode === 422) {
                        const { meta } = JSON.parse(res.data)
                        console.error(res, meta)
                        wx.showToast({
                            icon: 'none',
                            title: meta.error_message
                        })
                    } else if (res.statusCode === 413) {
                        wx.showModal({
                            title: '提示',
                            content: '上传图片不能超过8M',
                            showCancel: false
                        })
                        reject(res.statusCode)
                    } else {
                        const { data } = JSON.parse(res.data)
                        const { audio_url } = data
                        resolve(audio_url)
                    }
                },
                fail (res) {
                    reject(res)
                }
            })
        })
    },
    setClipboardData (content, success) {
        if (wx.setClipboardData) {
            wx.setClipboardData({
                data: content,
                success (res) {
                    if (!success) {
                        wx.showToast({
                            title: '内容已复制',
                            icon: 'success'
                        })
                    } else {
                        success()
                    }
                }
            })
        } else {
            updateTip()
        }
    },
    makePhoneCall (phoneNumber) {
        if (wx.makePhoneCall) {
            wx.makePhoneCall({
                phoneNumber
            })
        } else {
            updateTip()
        }
    },
    getSystemInfo () {
        return new Promise((resolve, reject) => {
            resolve({
                windowHeight: document.documentElement && document.documentElement.clientHeight ? document.documentElement.clientHeight : document.body.clientHeight,
                windowWidth: document.documentElement && document.documentElement.clientWidth ? document.documentElement.clientWidth : document.body.clientWidth
            })
        })
    },
    getImgInfo (src) {
        return new Promise((resolve, reject) => {
            const img = new Image()
            img.src = src
            resolve({
                width: img.width,
                height: img.height,
                path: src
            })
        })
    },
    downloadFile (options) {
        return new Promise((resolve, reject) => {
            wx.downloadFile({
                ...options,
                success: resolve,
                fail: reject
            })
        })
    },
    setTitle (content, show_app_name = true) {
        console.log('set title', content)
        let title = page_title
        if (content) {
            title = `${show_app_name ? `${title}-` : ''}${content}`
        }
        if (navigator.userAgent.toLowerCase().indexOf('tfsmy') > -1) {
            eshimin.setTitle({ title })
        } else {
            const tags = document.getElementsByTagName('title')
            if (tags && tags.length) {
                tags[0].innerHTML = title
            }
        }
    },
    chooseImage (option) {
        return new Promise((resolve, reject) => {
            const errorTip = (err) => {
                console.error(err)
                if (!err || err.errMsg != 'chooseImage:fail cancel') {
                    wx.showToast({ title: '接口故障，暂无法获取图片', icon: 'none' })
                }
                reject(err)
            }
            wx.chooseImage({
                ...option,
                success: ({ tempFilePaths }) => {
                    if (!tempFilePaths || !tempFilePaths.length) {
                        errorTip('接口故障，暂无法获取图片')
                    } else {
                        resolve(tempFilePaths)
                    }
                },
                fail: errorTip
            })
        })
    },
    getStorageSync (key) {
        return window.localStorage.getItem(key) ? JSON.parse(window.localStorage.getItem(key)) : ''
    },
    getStorage (key) {
        return new Promise((resolve, reject) => {
            try {
                const val = window.localStorage.getItem(key) ? JSON.parse(window.localStorage.getItem(key)) : ''
                resolve(val)
            } catch (err) {
                reject(err)
            }
        })
    },
    setStorageSync (key, data) {
        window.localStorage.setItem(key, JSON.stringify(data))
    },
    setStorage (key, data) {
        return new Promise((resolve, reject) => {
            try {
                window.localStorage.setItem(key, JSON.stringify(data))
                resolve()
            } catch (err) {
                reject(err)
            }
        })
    },
    observerRelativeViewPort (selector, { relativeOpt, success }, component) {
        if (typeof wx.createIntersectionObserver !== 'function') {
            return null
        }
        const ob = component ? component.createIntersectionObserver() : wx.createIntersectionObserver()
        if (ob && typeof ob.relativeToViewport === 'function') {
            ob.relativeToViewport(relativeOpt || {}).observe(selector, success)
        }
        return ob
    },
    authorize (scope) {
        return new Promise((success, fail) => {
            wx.authorize({
                scope,
                success,
                fail
            })
        })
    },
    getLocation () {
        return new Promise((success, fail) => {
            wx.getLocation({
                success,
                fail
            })
        })
    }
}

export default WX_API
